export default "__VITE_ASSET__6da287c7__"